module.exports = __webpack_public_path__ + "img/corporative.5f745ea6.svg";